import React from 'react';
import styles from './index.module.scss';

const TitlePreview = ({ title }) => {
    return (
        <div className={styles.container}>
            <span className={styles.title}>{title}</span>
        </div>
    );
};

export default TitlePreview;
